import { darken } from "@mui/material";
import { COLORS, DEFAULT_SHADOW, HALO } from "../../../constants";
export var baseChipStyles = {
    px: 3,
    py: 2.75,
    color: COLORS.P_HIGH_EMPHASIS,
    bgcolor: "primary.contrastText",
    border: "1px solid ".concat(COLORS.P_OUTLINE),
    height: "auto",
    borderRadius: "100px",
    span: {
        px: 2.5,
        fontSize: 16,
        lineHeight: "24px",
        letterSpacing: "0px",
    },
    ":active": {
        boxShadow: "none",
    },
    "&.MuiChip-sizeSmall": {
        py: 2.5,
        span: {
            fontSize: 14,
            lineHeight: "20px",
        },
    },
    ".MuiChip-icon": {
        width: "20px",
        height: "20px",
        m: 0,
        color: COLORS.BLACK,
    },
    ".MuiChip-deleteIcon": {
        height: "20px",
        width: "20px",
        m: 0,
        color: COLORS.BLACK,
    },
    ".MuiChip-deleteIcon svg": {
        width: "100%",
        height: "auto",
    },
    "&.Mui-disabled.Mui-disabled.Mui-disabled": {
        background: COLORS.LIGHT_GREY,
        opacity: 1,
        color: COLORS.P_DISABLED,
        ".MuiChip-deleteIcon, .MuiChip-deleteIcon svg": {
            color: COLORS.P_DISABLED,
        },
        ".MuiChip-icon": {
            color: COLORS.P_DISABLED,
        },
    },
    ".MuiCircularProgress-root": {
        color: "primary.contrastText",
    },
    "&.MuiChip-selected": {
        ".MuiChip-deleteIcon, .MuiChip-deleteIcon svg": {
            color: "primary.main",
        },
        ".MuiChip-icon": {
            color: "primary.main",
        },
    },
    /// PRIMARY
    "&.MuiChip-primary": {
        "&:hover": {
            bgcolor: COLORS.OVERLAY_HOVER,
        },
        "& > .MuiTouchRipple-root": {
            color: darken(COLORS.OVERLAY_PRESSED, 0.15),
        },
        "&:focus-visible": {
            bgcolor: "primary.contrastText",
            boxShadow: HALO,
        },
        "&.MuiChip-dragged": {
            bgcolor: COLORS.OVERLAY_SELECTED,
            boxShadow: DEFAULT_SHADOW,
        },
        "&.MuiChip-selected": {
            bgcolor: COLORS.OVERLAY_SELECTED,
            color: "primary.main",
            borderColor: "primary.main",
        },
    },
    /// SECONDARY
    "&.MuiChip-secondary": {
        px: 1.5,
        py: 1.5,
        bgcolor: "transparent",
        border: "none",
        span: {
            px: 1.5,
            fontSize: 14,
            lineHeight: "20px",
        },
        "&.MuiChip-sizeSmall": {
            py: 0.75,
            span: {
                fontSize: 12,
                lineHeight: "18px",
            },
        },
        "&:hover": {
            bgcolor: COLORS.OVERLAY_HOVER,
        },
        "& > .MuiTouchRipple-root": {
            color: darken(COLORS.OVERLAY_PRESSED, 0.15),
        },
        "&:focus-visible": {
            bgcolor: "primary.contrastText",
            boxShadow: HALO,
        },
        "&.MuiChip-dragged": {
            bgcolor: COLORS.OVERLAY_SELECTED,
            boxShadow: DEFAULT_SHADOW,
        },
        "&.MuiChip-selected": {
            bgcolor: COLORS.OVERLAY_SELECTED,
            color: "primary.main",
            borderColor: "primary.main",
        },
    },
    /// SECONDARY OUTLINE
    "&.MuiChip-secondaryOutline": {
        px: 1.5,
        py: 1.5,
        span: {
            px: 1.5,
            fontSize: 14,
            lineHeight: "20px",
        },
        "&.MuiChip-sizeSmall": {
            py: 0.75,
            span: {
                fontSize: 12,
                lineHeight: "18px",
            },
        },
        "&:hover": {
            bgcolor: COLORS.OVERLAY_HOVER,
        },
        "& > .MuiTouchRipple-root": {
            color: darken(COLORS.OVERLAY_PRESSED, 0.15),
        },
        "&:focus-visible": {
            bgcolor: "primary.contrastText",
            boxShadow: HALO,
        },
        "&.MuiChip-dragged": {
            bgcolor: COLORS.OVERLAY_SELECTED,
            boxShadow: DEFAULT_SHADOW,
        },
        "&.MuiChip-selected": {
            bgcolor: COLORS.OVERLAY_SELECTED,
            color: "primary.main",
            borderColor: "primary.main",
        },
    },
};
